export default {
  reservations: [],
  reservation: {},
  statuses: [],
  actions: [],
};
